import { useMissions } from "@/hooks/useMissions";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useAuth } from "@/hooks/useAuth";

interface LayoutProps {
  children: React.ReactNode;
  hideHeaderIfLoggedOut?: boolean;
  hideFooterIfLoggedOut?: boolean;
}

export const Layout = ({
  children,
  hideHeaderIfLoggedOut = false,
  hideFooterIfLoggedOut = false
}: LayoutProps) => {
  const { handleDailyLogin, handleSignup } = useMissions();
  const location = useLocation();
  const { user } = useAuth();

  // Effect for daily login mission - trigger on mount and when user changes
  useEffect(() => {
    if (user?.id) {
      handleDailyLogin();
    }
  }, [user?.id, handleDailyLogin]);

  // Effect for first signup mission - trigger when logged in user visits non-homepage
  useEffect(() => {
    if (location.pathname !== '/' && user?.id) {
      handleSignup();
    }
  }, [location.pathname, user?.id, handleSignup]);

  const shouldShowHeader = user || !hideHeaderIfLoggedOut;
  const shouldShowFooter = user || !hideFooterIfLoggedOut;

  return (
    <div className="flex flex-col min-h-screen bg-background">
      {shouldShowHeader && <Header />}
      <main className="flex-grow">
        {children}
      </main>
      {shouldShowFooter && <Footer />}
    </div>
  );
};
